import { render } from "./CampaignDashboard.vue?vue&type=template&id=d792c2fe"
import script from "./CampaignDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignDashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\root\\baam\\viribuz\\viribuz-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__